import React from 'react';

export const CheckBoxIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 0.5C2.51472 0.5 0.5 2.51472 0.5 5V17C0.5 19.4853 2.51472 21.5 5 21.5H17C19.4853 21.5 21.5 19.4853 21.5 17V5C21.5 2.51472 19.4853 0.5 17 0.5H5Z" fill="white" stroke="#959595"/>
    </svg>
  );
};

export const CheckBoxIconFill = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 4C0 1.79086 1.79086 0 4 0H16C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 0 18.2091 0 16V4Z" fill="#2b3990"/>
      <path d="M6 10.0914L8.75277 12.8442L14.597 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  );
};
